module.exports = __webpack_public_path__ + "img/IMGP8628.02fd72d6.jpg";